import * as z from "zod";

export const discountCodePrefixSchema = z
  .string()
  .min(3, "Prefix must be at least 3 characters")
  .max(20, "Prefix must be 20 characters or less")
  .regex(
    /^[A-Z0-9-]+$/,
    "Prefix must contain only uppercase letters, numbers, and hyphens",
  );
